import {compose} from 'redux';
import {connect} from 'react-redux';
import {graphql} from 'react-apollo';
import React, {Component} from 'react';
import {SVGIcon} from '@homeaway/react-svg';
import throttle from 'lodash.throttle';
import {withAuth} from '../../components/auth';
import {withTranslationsAsProps} from '../../components/translations';
import {withUser} from '../user/user';
import {VOTETHUMB__16, VOTEDTHUMB__16, VOTEPLUS__16, VOTEDPLUS__16, VOTETHUMB__32, VOTEPLUS__32, VOTEDPLUS__32} from '../../components/svg-def';
import {ADD_VOTE, REMOVE_VOTE, voteUp, voteDown, Vote} from './votes-graphql';
import classnames from 'classnames';

export const plusLocales = ['RU', 'AU', 'GR', 'SC'];

export const isPlusLocale = (locale = '') => {
    let isAPlusLocale = false;
    plusLocales.forEach((plusLocal) => {
        isAPlusLocale = isAPlusLocale || (locale.toUpperCase().indexOf(plusLocal) > -1);
    });
    return isAPlusLocale;
};

export class VoteThumb extends Component {
    constructor(props) {
        super(props);
        this.buttonRef = React.createRef();
        this.vote = throttle(this.vote, 250);
    }

    componentDidMount() {
        // onClick via React does not work when rendered inside a google overlay
        // istanbul ignore next
        if (this.buttonRef.current) {
            this.buttonRef.current.addEventListener('click', this.vote.bind(this));
        }
    }

    componentWillUnmount() {
        // istanbul ignore next
        if (this.buttonRef.current) {
            this.buttonRef.current.removeEventListener('click', this.vote);
        }
    }

    vote(event) {
        event.stopPropagation();
        if (this.props.isMine) {
            voteDown(this.props);
        } else {
            voteUp(this.props);
        }
    }

    render() {
        const {
            isMine,
            label,
            showLabel = false,
            markup,
            isSmall
        } = this.props;
        let className = 'vote';

        const withLabel = (showLabel ? 'has-label' : 'no-label');

        if (isMine) {
            className = 'voted';
        }

        return (
                <button
                    aria-label={label}
                    className={classnames(`btn btn-default btn-xs vote-btn__button vote-btn__button--${className} vote-btn__button--${withLabel}`, {
                        'vote-btn--small': isSmall
                    })}
                    ref={this.buttonRef}
                    type="button"
                >
                    <SVGIcon className={`vote-btn__thumb vote-btn__thumb--${className}`} markup={markup}/>
                    {showLabel && label}
                </button>
        );
    }

}

VoteThumb.defaultProps = {
    ...Vote,
    label: ''
};

/* istanbul ignore next */
export const DownThumb = compose(
    withAuth,
    graphql(REMOVE_VOTE)
)(VoteThumb);

/* istanbul ignore next */
export const UpThumb = compose(
    withAuth,
    graphql(ADD_VOTE)
)(VoteThumb);

const MARKUP_MINE = {
    small: {
        plus: VOTEDPLUS__16,
        thumb: VOTEDTHUMB__16,
    },
    notsmall: {
        plus: VOTEDPLUS__32,
        thumb: VOTETHUMB__32,
    }
};

const MARKUP_NOT_MINE = {
    small: {
        plus: VOTEPLUS__16,
        thumb: VOTETHUMB__16,
    },
    notsmall: {
        plus: VOTEPLUS__32,
        thumb: VOTETHUMB__32,
    }
};

const getMarkup = (isSmall, isPlus, isMine) => {
    const sizeKey = isSmall ? 'small' : 'notsmall';
    const typeKey = isPlus ? 'plus' : 'thumb';

    return isMine ? MARKUP_MINE[sizeKey][typeKey] : MARKUP_NOT_MINE[sizeKey][typeKey];
};

export function VoteButton({
    endDate,
    isMine,
    langVote,
    langVoted,
    locale,
    listingId,
    showLabel,
    startDate,
    tripBoardUuid,
    uuid,
    voter,
    role,
    isSmall = false
}) {
    const isPlus = isPlusLocale(locale);
    let markup = getMarkup(isSmall, isPlus, isMine);
    let label = langVote;
    let Thumb = UpThumb;

    if (isMine) {
        label = langVoted;
        Thumb = DownThumb;
    }

    return (
        <div className="vote-btn">
            <Thumb
                endDate={endDate}
                isMine={isMine}
                label={label}
                listingId={listingId}
                markup={markup}
                showLabel={showLabel}
                startDate={startDate}
                tripBoardUuid={tripBoardUuid}
                uuid={uuid}
                voter={voter}
                isSmall={isSmall}
                role={role}
            />
        </div>
    );
}

VoteButton.defaultProps = {
    ...Vote,
    locale: 'en_US'
};

export const mapStateToProps = ({
    system: {
        locale = 'en_US'
    } = {}
}) => ({locale});

export default compose(
    withUser,
    withTranslationsAsProps({
        'tripboards.vote.tooltip': 'langVote',
        'tripboards.voted.tooltip': 'langVoted'
    }),
    connect(mapStateToProps)
)(VoteButton);



// WEBPACK FOOTER //
// ./src/universal/tripboard/votes/vote-button.js